import cx from 'classnames';
import React, { useState } from 'react';

import ArrowDropDown from '../Icons/ArrowDropDown';
import ArrowDropUp from '../Icons/ArrowDropUp';

import s from './collapsible-alert.module.css';
import { getAlertIcon } from './getAlertIcon';
import type { CommonAlertProps } from './types';

export interface CollapsibleAlertProps extends CommonAlertProps {
    showContentByDefault: boolean;
    title: string;
}

export const CollapsibleAlert = ({
    children,
    type,
    className,
    title,
    showContentByDefault,
    ...props
}: CollapsibleAlertProps) => {
    const [showContent, setShowContent] = useState(showContentByDefault);

    const onCollapse = () => {
        setShowContent(!showContent);
    };

    return (
        <div className={cx(className, s[type])} {...props}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions*/}
            <div className={cx(s.header, showContent && s.expanded)} onClick={onCollapse}>
                <div>{getAlertIcon(type)}</div>
                <h3 className={s['line-height-24']}>{title}</h3>
                <button type="button" className={s.collapse}>
                    {showContent ? <ArrowDropUp /> : <ArrowDropDown />}
                </button>
            </div>
            {showContent && children && <div className={s.body}>{children}</div>}
        </div>
    );
};
